<style>
table {
  border-collapse: collapse;
  width: 100%;
}

th, td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

th {
  background-color: #f2f2f2;
}
</style>
<template>

    <div>
      <vs-popup
      class="holamundo"
      title="Fiyat Listesi Sil"
      :active.sync="deletePopupActive"
      v-esc="escape"
    >
      <vs-row vs-type="flex" vs-w="12">
        <p>Bu Fiyat Listesini Silmek İstediğinize Eminmisiniz ?</p>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="mt-3" vs-justify="space-between">
        <vs-button
          type="gradient"
          color="primary"
          @click="
            deletePopupActive = false;
            deletedId = null;
          "
          >Vazgeç</vs-button
        >
        <vs-button
          type="gradient"
          color="danger"
          icon-pack="feather"
          icon="icon-trash"
          @click="deleteListMethod(deletedId)"
        >
          Sil
        </vs-button>
      </vs-row>
    </vs-popup>
      <vs-row vs-type="flex" vs-w="12">
              <vs-col v-if="($isCenterBranch() || $isRegionalCenterBranch()) && isNewPriceListPermission" vs-type="flex" class="w-auto">
                <vx-tooltip text="Yeni Fiyat Listesi" position="top">
                  <vs-button
                    @click="addNewData"
                    class="panel-action text-success xlarge-button panel-action-box-shadow"
                    color="transparent"
                    icon-pack="feather"
                    icon="icon-plus"
                  >
                  </vs-button>
                </vx-tooltip>
              </vs-col>
            </vs-row>
            <data-view-sidebar
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      @refreshTable="refreshTable"
      :data="sidebarData"
      :data3="items"
    />
        <my-popup :isSidebarActive="show" :data="currentItem" :data2="priceList" :data3="additiveProducts" :name="name" @close="show=false" ></my-popup>
        <vs-table :data="items" v-model="selected" @selected="handleSelected">
      <template slot="header">
      </template>
      <template slot="thead">
        <vs-th class="w-5/12">
          FİYAT LİSTESİ İSMİ
        </vs-th>
        <vs-th class="w-7/12">
          İşlemler
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
          <vs-td :data="data[indextr].email">
            {{tr.name}}
          </vs-td>

          <vs-td :data="data[indextr].id">
<vs-button  color="primary" type="filled" @click="showPopup(tr)">Ürün Fiyatları</vs-button>
<vs-button color="warning" type="filled" @click="editData(tr)">Güncelle</vs-button>
<vs-button color="danger" type="filled" @click.stop="
                  deletedId = tr.id;
                  deletePopupActive = true;
                ">Sil</vs-button>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    </div>
  </template>

  <script>
  import {
    getBranchProductPriceLists,
    getAllBranchProductPriceByBranchId,
    getAllAdditiveProducts,deleteList
  } from "@/api/BranchProductPrice.js";
  import MyPopup from './MyPopup.vue'
  import DataViewSidebar from "./NewPriceList.vue";
  import {isGranted} from "@/utils/auth";
  export default {
    components: {
        MyPopup,
        DataViewSidebar
  },

    data() {
      return {
        items: [],
        show:false,
        currentItem: {},
        name:"",
        priceList:[],
        additiveProducts:[],
        addNewDataSidebar: false,
        sidebarData: {},
        deletePopupActive: false,
        deletedId: null,
        selected: "",
      }
    },
    computed:{
      isNewPriceListPermission(){
      return isGranted("price_list_write")
    },
    isDeletePriceListPermission(){
      return isGranted("price_list_delete")
    }
    },
  methods: {
    deleteListMethod : async function(val,amount){
        deleteList(val,amount).then(res=>{
          this.deletePopupActive = false;
  })
  .catch(err =>{
    this.$fire({
              title: "Hata ! ",
              text: err.response.data.Errors[0].Message,
              type: "error"
            });
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: err.response.data.Errors[0].Message
          });
  })
      },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
      val == false ? (this.selected = "") : null;
    },
    refreshTable:async function() {
      this.items=await getBranchProductPriceLists();
    },
    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    editData(data) {
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    escape() {
      if (this.deletePopupActive == true) {
        this.deletePopupActive = false;
        this.deletedId = null;
      }
    },
    deleteData (id) {
      deletePriceById(id).then((res) => {
        if (res && res.status == 200) {
        //   this.$store.dispatch("branch/removeBranch", id).then(() => {
        //     this.deletePopupActive = false;
        //     this.$vs.notify({
        //       color: "success",
        //       title: "Silme İşlemi",
        //       text: "Şube Başarıyla Silindi",
        //     });
        //   });
        this.$vs.notify({
               color: "success",
               title: "Silme İşlemi",
               text: "Şube Başarıyla Silindi",
             });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Silme İşlemi Başarısız !",
          });
        }
      });
    },
    showPopup:async function(item) {
        this.currentItem = item.id;
        this.name=item.name
      this.priceList= await getAllBranchProductPriceByBranchId(item.id)
      this.additiveProducts= await getAllAdditiveProducts(item.id)
      this.show = true;
    }
  },
    created: async function () {
    this.items=await getBranchProductPriceLists();
  },
  watch: {
    selected: function (val) {
      if (val != "" && this.AppActiveUser.branch.id == 1) this.editData(val);
    }
  }
  }
  </script>